import styled from 'styled-components';
import { theme, toRem } from 'design';

// Used for the sidebar content
export const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: ${toRem(theme.space.sm)};
`;

// Used for sections within the sidebar content
export const ContentSection = styled.section`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: ${toRem(theme.space.sm)};
  margin: ${toRem(theme.space.sm)} 0;
`;

// Used for items within the sidebar content
export const RowItem = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${toRem(theme.space.sm)};

  p {
    color: ${theme.color.neutral[500]};
  }

  &.business-date {
    margin-bottom: ${toRem(theme.space.lg)};

    p {
      color: ${theme.color.neutral[900]};
    }
  }

  &.total {
    p {
      color: ${theme.color.neutral[900]};
    }
  }
`;
